module.exports = __webpack_public_path__ + "img/gseven.f8de2811.jpeg";